import React from 'react'
import { useLatestNews, LatestNewsProps } from './useLatestNews'
import styles from './LatestNews.module.scss'
import { Link } from 'react-router-dom'
import TitleSection from 'components/TitleSection/TitleSection'
import NewsCard from 'components/NewsCard/NewsCard'
import AnimatedContainer from 'components/AnimatedContainer/AnimatedContainer'

const LatestNews: React.FC<LatestNewsProps> = (props: LatestNewsProps) => {
  const {
    latestNewsData,
    isAr,
    animations,
    animationsReversed,
    selectedLanguage,
    t,
  } = useLatestNews(props)

  return (
    <section id='latest-news' className={styles['latest-news']}>
      <TitleSection title={t('latestNews')} />
      <div className='container'>
        <div className='row mb-4 mb-lg-5'>
          {latestNewsData && latestNewsData.length ? (
            latestNewsData.map((item, index) => {
              const description = isAr ? item.descriptionAr : item.descriptionEn
              let shortDescription = ''

              if (
                description &&
                description.length > 0 &&
                description[0].children &&
                description[0].children.length > 0
              ) {
                const firstText = description[0].children[0].text
                shortDescription = `${firstText.substring(0, 100)}...`
              } else shortDescription = t('noDetails')

              return (
                <div
                  key={`item-${item.id}-${index}`}
                  className='col-lg-4 mb-3 mb-lg-0'
                >
                  <AnimatedContainer
                    animation={
                      isAr
                        ? animations[index % animations.length]
                        : animationsReversed[index % animationsReversed.length]
                    }
                    extraCssClasses='h-100'
                  >
                    <NewsCard
                      image={item.image}
                      description={shortDescription}
                      title={isAr ? item.titleAr : item.titleEn}
                      author={isAr ? item.author.nameAr : item.author.nameEn}
                      authorImage={item.author.photo}
                      category={item.category.nameAr}
                      url={`/${selectedLanguage}/NewsDetails/${item.slugAr}`}
                      date={item.publishedAt.split('T')[0]}
                      isAr={isAr}
                      t={t}
                    />
                  </AnimatedContainer>
                </div>
              )
            })
          ) : (
            <div
              className={`col-12 text-center fs-4 fw-bold pb-4 ${styles['no-data']}`}
            >
              {t('noData')}
            </div>
          )}
        </div>
        <div className='row'>
          <div className='col-12 text-center'>
            <Link to='/News' className='btn btn-secondary px-5 py-2'>
              {t('allNews')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LatestNews
